import { InsightsTopTable } from "@/components/insights/InsightsTopTable";
import { formatSeconds } from "@/format/time";
import { useMostActiveUsers } from "@/queries/insights-queries";
import { type TimeRange } from "@/routes/insights/insights";
import type { Timestamp } from "@bufbuild/protobuf";
import { useMemo, type FC } from "react";

type Props = {
    startTimestamp: Timestamp;
    endTimestamp: Timestamp;
    selectedRange: TimeRange;
};
export const InsightsTopTablesList: FC<Props> = ({ startTimestamp, endTimestamp, selectedRange }) => {
    const {
        data: topUsers,
        isLoading: isLoadingTopUsers,
        fetchNextPage: fetchNextUsersPage,
        isFetchingNextPage: isFetchingNextUsersPage,
    } = useMostActiveUsers(startTimestamp, endTimestamp, selectedRange);

    const topActiveUsersData = useMemo(() => {
        const data = topUsers?.pages
            .flatMap((page) => page.users)
            .map((user) => ({
                // for deleted users, we show at least a user ID
                name: user.userName || user.userId,
                time: formatSeconds(user.totalRuntimeSeconds),
                avatar: user.userAvatarUrl,
                key: user.userId,
            }));
        return data ?? [];
    }, [topUsers]);

    return (
        <div className="mx-auto grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <InsightsTopTable
                title="Most active users"
                subtitle={selectedRange.label}
                isLoading={isLoadingTopUsers || isFetchingNextUsersPage}
                values={topActiveUsersData ?? []}
                onScrollEnd={fetchNextUsersPage}
            />

            <InsightsTopTable
                title="Top projects"
                subtitle={selectedRange.label}
                values={[{ name: "Pending Implementation", time: "420", key: "pending-implementation" }]}
            />

            <InsightsTopTable
                title="Top environment classes"
                subtitle={selectedRange.label}
                values={[{ name: "Not shipped yet", time: "😮", key: "not-shipped-yet" }]}
            />
        </div>
    );
};
